import { TOKEN_TYPE } from "../TokenType.js";
import Token from "../Token.js";

export default class RightVectorToken extends Token {
    constructor( value ) {
        super( TOKEN_TYPE.RIGHT_VECTOR, value );
    }

    toString() {
        return this.value;
    }
}
